import { createSlice } from "@reduxjs/toolkit";
import { updatePassportDetails } from "./PassportAction";

const passportSlice = createSlice({
  name: "Passport",
  initialState: {
    loading: false,
    error: false,
    success: false,
    details: {}
  },
  reducers: {
    clearError: (state) => {
      state.verifyError = false;
    },
    clearLoading: (state) => {
        state.loading = false;
    },
    clearSuccess: (state) => {
        state.success = false;
    },
    clearDetails: (state) => {
        state.details = {}
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updatePassportDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatePassportDetails.fulfilled, (state, action) => {
        state.success = true;
        state.loading = false;
        state.error = false;
      })
      .addCase(updatePassportDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
      });
  },
});

const passportAction = passportSlice.actions;


export { passportAction, passportSlice };
